import type { PushCampaignStatus } from "../../types";

/**
 * 配信状態の表示名
 */
const CAMPAIGN_STATUS_LABELS: Record<PushCampaignStatus, string> = {
  draft: "下書き",
  queued: "配信待ち",
  processing: "配信中",
  completed: "配信済み",
  partial_failed: "一部失敗",
  failed: "失敗",
} as const;

/**
 * 配信状態の表示名を得る
 *
 * @param status - 配信状態
 * @returns 表示名
 */
export const formatCampaignStatus = (status: PushCampaignStatus) => {
  return CAMPAIGN_STATUS_LABELS[status];
};
